exports.enterCodeCountdownTimeMilliseconds = 1000 * 60 * 5; // 5 minutes - 1000 * 60 * 5
